import { render, staticRenderFns } from "./afterSale.vue?vue&type=template&id=3fa860e4&scoped=true&"
import script from "./afterSale.vue?vue&type=script&lang=js&"
export * from "./afterSale.vue?vue&type=script&lang=js&"
import style0 from "./afterSale.vue?vue&type=style&index=0&id=3fa860e4&prod&lang=less&scoped=true&"
import style1 from "./afterSale.vue?vue&type=style&index=1&id=3fa860e4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa860e4",
  null
  
)

export default component.exports